import { queryOptions, useQuery } from '@tanstack/react-query';
import { getPresignedUrl } from '@/services/api/reports';
import { type ParsedCsv, parseCsv } from '@/utils/csv';

export const REPORT_CSV_QUERY_KEY = ['report-csv'] as const;

const fetchReportCsv = async (key: string): Promise<ParsedCsv> => {
  const { url } = await getPresignedUrl(key);
  // Plain fetch on purpose: the presigned URL is self-authorising and the bop
  // bearer token must not be sent to S3.
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch report file (HTTP ${response.status})`);
  }
  return parseCsv(await response.text());
};

export const reportCsvQueryOptions = (key: string) =>
  queryOptions({
    queryKey: [...REPORT_CSV_QUERY_KEY, key],
    queryFn: () => fetchReportCsv(key),
    // Report files are written once and never rewritten under the same key.
    staleTime: Number.POSITIVE_INFINITY,
  });

export const useReportCsv = (key: string) => useQuery(reportCsvQueryOptions(key));
